import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
  href?: string;
  scrollToId?: string;
}
export function CTAButton({
  text = 'SÍ, QUIERO RECUPERAR MI PAZ AHORA',
  className = '',
  onClick,
  href,
  scrollToId
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      trackAddToCart();
      window.open(href, '_blank', 'noopener,noreferrer');
    } else if (scrollToId) {
      const el = document.getElementById(scrollToId);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
    onClick?.();
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`w-full sm:w-auto bg-brand-amber hover:bg-brand-amber-light text-brand-dark font-bold py-4 px-8 rounded-sm shadow-lg transition-colors duration-300 text-sm sm:text-base tracking-wide ${className}`} data-id="element-15">
      {text}
    </motion.button>;
}